<template>
    <div>

        <employee-discount-component :base_url="base_url"
            :formInputs="formInputs(studentRequestFromData, 'employee_discount')"
            :institute_currency="courseCalculatorResult?.course?.institute_currency" :tra="tra"
            @discount-updated="handleDiscountUpdate">
        </employee-discount-component>

        <courses-component :institute_id="institute_id" :base_url="base_url" :pref_currency="pref_currency"
            v-model:start-date="calculatorData.start_date" v-model:course-weeks="calculatorData.course_weeks"
            v-model:course-id="calculatorData.course_id" :errors="errors" :old="old"
            :employee_discount="employee_discount" :instituteVacationDates="disabledVacationDates" :tra="tra">
        </courses-component>

        <residences-component :institute_id="institute_id" :base_url="base_url" :pref_currency="pref_currency"
            :start_date="calculatorData.start_date" :courseWeeks="calculatorData.course_weeks"
            v-model:residence-id="calculatorData.residence_id" v-model:residence-weeks="calculatorData.residence_weeks"
            @update:custom-residence="handleCustomResidenceUpdate" :custom-residence-data="customResidenceData"
            :is_dashboard_user="is_dashboard_user" :errors="errors" :old="old" :tra="tra">
        </residences-component>

        <div class="row">
            <div class="col-md-12">
                <airports-component :institute_id="institute_id" :base_url="base_url" :pref_currency="pref_currency"
                    :start_date="calculatorData.start_date" v-model:airport-id="calculatorData.airport_id"
                    @update:custom-airport="handleCustomAirportUpdate" :custom-airport-data="customAirportData"
                    :is_dashboard_user="is_dashboard_user" :errors="errors" :old="old" :tra="tra">
                </airports-component>
            </div>

            <div class="col-md-12">
                <div v-if="insurance_availability">
                    <insurance-component :institute_id="institute_id" :base_url="base_url"
                        :pref_currency="pref_currency" :courseWeeks="calculatorData.course_weeks"
                        v-model:insurance-checker="calculatorData.insurance_checker"
                        :start_date="calculatorData.start_date" v-model:insurance-availability="insurance_availability"
                        :errors="errors" :old="old" :tra="tra">
                    </insurance-component>
                </div>
                <div v-if="visa_availability">
                    <visa-component :country_id="country_id" :base_url="base_url" :pref_currency="pref_currency"
                        :course_weeks="calculatorData.course_weeks" v-model:visa-checker="calculatorData.visa_checker"
                        v-model:visa-availability="visa_availability" :errors="errors" :old="old" :tra="tra">
                    </visa-component>
                </div>
            </div>
            <calculator-result-component :courseCalculatorResult="courseCalculatorResult" :base_url="base_url"
                :formInputs="formInputs(studentRequestFromData)" :tra="tra">
            </calculator-result-component>
        </div>

        <calc-bottom-btns-component :formInputs="formInputs(studentRequestFromData)" :base_url="base_url" :tra="tra">
        </calc-bottom-btns-component>

        <div class="modal fade" id="institute_vacation_checker_modal" tabindex="-1" aria-labelledby="vacationModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <div class="modal-content p-4">
                    <button type="button" class="close modal-close-btn-absolute" data-dismiss="modal">&times;</button>
                    <div class="modal-body text-right">
                        <h4 class="mb-3 text-main-color font-weight-bold">{{ tra.institute_vacation_notice_title }}</h4>

                        <div v-if="vacation">
                            <p class="mb-3">
                                {{ tra.institute_vacation_notice }}
                                <strong>{{ vacation.name }}</strong>
                                {{ tra.for_duration }} <strong>{{ getVacationWeeksText(vacation.vacation_weeks)
                                    }}</strong>،
                                {{ tra.classes_resume }}
                            </p>

                            <hr class="my-2">

                            <span class="text-danger">
                                <strong>{{ tra.vacation_period_from }} {{ vacation.vacation_from_date }}
                                    {{ tra.to }} {{ vacation.vacation_to_date }}</strong>
                            </span>

                            <div v-if="hasResidence" class="mt-4">
                                <h4 class="mb-3">
                                    {{ tra.extend_accommodation_stay }}
                                    {{ getVacationWeeksText(vacation.weeks) }}؟
                                </h4>

                                <div class="row">
                                    <div class="col-md-4 col-6">
                                        <button @click="hideVacationModal" type="button"
                                            class="btn w-100 text-center rounded-10 text-white bg-main-color">
                                            {{ tra.no }}
                                        </button>
                                    </div>
                                    <div class="col-md-4 d-md-block d-none"></div>
                                    <div class="col-md-4 col-6">
                                        <button @click="addVacationWeeks" type="button"
                                            class="btn w-100 text-center rounded-10 text-white bg-secondary-color">
                                            {{ tra.yes }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div v-else class="text-center mt-4">
                                <button @click="hideVacationModal" type="button"
                                    class="btn px-5 py-2 rounded-10 text-white bg-secondary-color">
                                    {{ tra.ok }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import CoursesComponent from "./CoursesComponent.vue";
import ResidencesComponent from "./ResidencesComponent.vue";
import AirportsComponent from "./AirportsComponent.vue";
import InsuranceComponent from "./InsuranceComponent.vue";
import VisaComponent from "./VisaComponent.vue";
import CalcBottomBtnsComponent from "./CalcBottomBtnsComponent.vue";
import debounce from 'lodash/debounce';
import CalculatorResultComponent from './CalculatorResultComponent.vue';
import EmployeeDiscountComponent from './EmployeeDiscountComponent.vue';

export default {
    components: {
        CoursesComponent,
        ResidencesComponent,
        AirportsComponent,
        InsuranceComponent,
        VisaComponent,
        CalculatorResultComponent,
        CalcBottomBtnsComponent,
        EmployeeDiscountComponent,
    },
    props: ['institute_id', 'base_url', 'pref_currency', 'course_id', 'country_id', 'errors', 'old', 'tra', 'is_dashboard_user'],
    data() {
        return {
            calculatorData: {
                course_id: this.course_id,
                start_date: null,
                course_weeks: null,
                residence_id: null,
                residence_weeks: null,
                airport_id: null,
                insurance_checker: null,
                visa_checker: null,
                custom_residence: [],
                custom_airport: [],
            },
            insurance_availability: true,
            visa_availability: true,
            courseCalculatorResult: null,
            isLoading: false,
            initialLoad: true,
            employee_discount: {},
            vacation: null,
            disabledVacationDates: [],
            vacationModal: true,
            isVacationCheckInProgress: false,
            lastVacationModalFire: null,
            modalCloseTime: null,
            customResidenceData: null,
            customAirportData: null,
            calculatorAbortController: null,
            vacationAbortController: null,
        };
    },

    computed: {
        calculatorParams() {
            return {
                institute_id: this.institute_id,
                course_id: this.calculatorData.course_id,
                start_date: this.calculatorData.start_date,
                course_weeks: this.calculatorData.course_weeks,
                residence_id: this.calculatorData.residence_id,
                residence_weeks: this.calculatorData.residence_weeks,
                airport_id: this.calculatorData.airport_id,
                insurance_checker: this.calculatorData.insurance_checker,
                visa_checker: this.calculatorData.visa_checker,
                employee_discount: this.employee_discount,
                pref_currency: this.pref_currency,
                custom_residence: this.calculatorData.residence_id == 'custom_residence' ? this.calculatorData.custom_residence : [],
                custom_airport: this.calculatorData.airport_id == 'custom_airport' ? this.calculatorData.custom_airport : [],
                lang: window.current_locale,
            };
        },
        studentRequestFromData() {
            return {
                csrf_token: window.csrf_token,
                institute_id: this.institute_id,
                course_id: this.calculatorData.course_id,
                start_date: this.calculatorData.start_date,
                course_weeks: this.calculatorData.course_weeks,
                residence_id: this.calculatorData.residence_id,
                residence_weeks: this.calculatorData.residence_weeks,
                airport_id: this.calculatorData.airport_id,
                insurance_checker: this.calculatorData.insurance_checker,
                visa_checker: this.calculatorData.visa_checker,
                compare_offer: false,
            };
        },
        hasMinimumData() {
            return this.calculatorData.course_id &&
                this.calculatorData.start_date;
        },
        hasResidence() {
            return this.calculatorData.residence_id &&
                this.calculatorData.residence_id !== 0 &&
                this.calculatorData.residence_id !== 'no-residence-needed';
        }
    },

    watch: {
        calculatorParams: {
            handler(newParams, oldParams) {
                if (!this.initialLoad) {
                    this.debouncedGetCalculatorResult();
                }
            },
            deep: true
        },
        'calculatorData.start_date': {
            handler(newStartDate, oldStartDate) {
                if (newStartDate && newStartDate !== oldStartDate && this.calculatorData.course_weeks) {
                    this.resetVacationModal();
                    this.debouncedVacationChecker();
                }
            }
        },
        'calculatorData.course_weeks': {
            handler(newCourseWeeks, oldCourseWeeks) {
                if (newCourseWeeks && newCourseWeeks !== this.calculatorData.residence_weeks && this.hasResidence) {
                    this.calculatorData.residence_weeks = newCourseWeeks;
                }

                if (newCourseWeeks && newCourseWeeks !== oldCourseWeeks && this.calculatorData.start_date) {
                    this.resetVacationModal();
                    this.debouncedVacationChecker();
                }
            },
            immediate: false
        },
        'calculatorData.residence_id': {
            handler(newResidenceId, oldResidenceId) {
                if (newResidenceId == null || newResidenceId == 0 || newResidenceId == 'no-residence-needed') {
                    this.calculatorData.residence_weeks = null;
                } else {
                    this.calculatorData.residence_weeks = this.calculatorData.course_weeks;
                }

                if (newResidenceId !== oldResidenceId &&
                    this.calculatorData.start_date &&
                    this.calculatorData.course_weeks) {
                    this.checkVacationWithCooldown();
                }
            },
            immediate: false
        },
        'calculatorData.residence_weeks': {
            handler(newResidenceWeeks, oldResidenceWeeks) {
                // Only check vacation if residence weeks were manually changed (not from residence selection)
                if (newResidenceWeeks &&
                    newResidenceWeeks !== oldResidenceWeeks &&
                    newResidenceWeeks !== this.calculatorData.course_weeks &&
                    this.calculatorData.start_date &&
                    this.hasResidence &&
                    !this.isVacationCheckInProgress) {
                    this.checkVacationWithCooldown();
                }
            }
        }
    },

    methods: {
        handleDiscountUpdate(discountData) {
            this.employee_discount.discount = discountData.employee_discount;
            this.employee_discount.discount_type = discountData.employee_discount_type;
        },

        handleCustomResidenceUpdate(customResidence) {
            this.calculatorData.custom_residence = customResidence;
        },

        handleCustomAirportUpdate(customAirport) {
            this.calculatorData.custom_airport = customAirport;
        },

        checkVacationWithCooldown() {
            const currentTime = Date.now();

            // Check if modal was recently closed (within 2 seconds)
            if (this.modalCloseTime && (currentTime - this.modalCloseTime < 2000)) {
                return;
            }

            // Check if vacation check was recently fired (within 4 seconds)
            if (!this.lastVacationModalFire || (currentTime - this.lastVacationModalFire >= 4000)) {
                this.resetVacationModal();
                this.debouncedVacationChecker();

                this.lastVacationModalFire = currentTime;
            }
        },

        parseUrlParams() {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('course_id')) {
                this.calculatorData.course_id = Number(urlParams.get('course_id'));
            }
            if (urlParams.get('course_weeks')) {
                this.calculatorData.course_weeks = Number(urlParams.get('course_weeks'));
            }
            if (urlParams.get('start_date')) {
                this.calculatorData.start_date = urlParams.get('start_date');
            }
            if (urlParams.get('residence_id') !== null && urlParams.get('residence_id') !== '') {
                this.calculatorData.residence_id = Number(urlParams.get('residence_id'));
            }
            if (urlParams.get('residence_weeks')) {
                this.calculatorData.residence_weeks = Number(urlParams.get('residence_weeks'));
            }
            if (urlParams.get('airport_id') !== null && urlParams.get('airport_id') !== '') {
                this.calculatorData.airport_id = Number(urlParams.get('airport_id'));
            }
            if (urlParams.get('insurance_checker') !== null && urlParams.get('insurance_checker') !== '') {
                this.calculatorData.insurance_checker = Number(urlParams.get('insurance_checker'));
            }
            if (urlParams.get('visa_checker') !== null && urlParams.get('visa_checker') !== '') {
                this.calculatorData.visa_checker = Number(urlParams.get('visa_checker'));
            }
        },

        async getCourseCalculatorResult() {
            // Cancel previous request if exists
            if (this.calculatorAbortController) {
                this.calculatorAbortController.abort();
            }

            if (!this.hasMinimumData) {
                console.log('first')
                this.courseCalculatorResult = null;
                return;
            }

            // Create new AbortController for this request
            this.calculatorAbortController = new AbortController();

            this.isLoading = true;

            try {
                const response = await axios.get(this.base_url + '/api/get-course-calculator-result', {
                    signal: this.calculatorAbortController.signal,
                    params: {
                        ...this.calculatorParams,
                    },
                });

                this.courseCalculatorResult = response.data;

                // Extract custom residence data with converted price from API response
                if (response.data.residence && response.data.residence.residence_id === 'custom_residence') {
                    this.customResidenceData = {
                        description: response.data.residence.description,
                        price: response.data.residence.price,
                    };
                }

                if (response.data.airport && response.data.airport.id === 'custom_airport') {
                    this.customAirportData = {
                        description: response.data.airport.name,
                        price: response.data.airport.price,
                    };
                }

            } catch (error) {
                // Ignore cancelled requests
                if (error.code === 'ERR_CANCELED' || error.message === 'canceled') {
                    console.log('Calculator request cancelled - new request started');
                    return;
                }

                console.error('Error fetching calculator result:', error);
                if (error.response && error.response.status === 429) {
                    console.warn('Rate limit exceeded. Retrying in 2 seconds...');
                    setTimeout(() => {
                        this.getCourseCalculatorResult();
                    }, 2000);
                }
            } finally {
                this.isLoading = false;
            }
        },

        createDebouncedMethod() {
            this.debouncedGetCalculatorResult = debounce(this.getCourseCalculatorResult, 1000);
            this.debouncedVacationChecker = debounce(this.instituteVacationChecker, 500);
        },

        formInputs(obj, type = null) {
            return `
                <input type="hidden" name="_token" value="${obj.csrf_token == null ? '' : obj.csrf_token}">
                <input name="institute_id" type="hidden" value="${obj.institute_id == null ? '' : obj.institute_id}">
                <input name="course_id" type="hidden" value="${obj.course_id == null ? '' : obj.course_id}">
                <input name="start_date" type="hidden" value="${this.formatDate(obj.start_date)}">
                <input name="course_weeks" type="hidden" value="${obj.course_weeks ?? 1}">
                <input name="residence_id" type="hidden" value="${obj.residence_id == null ? '' : obj.residence_id}">
                <input name="residence_weeks" type="hidden" value="${obj.residence_weeks ?? 1}">
                <input name="airport_id" type="hidden" value="${obj.airport_id == null ? '' : obj.airport_id}">
                ${this.insurance_availability ? `<input name="insurance_checker" type="hidden" value="${obj.insurance_checker == null ? '' : obj.insurance_checker}">` : ''}
                ${this.visa_availability ? `<input name="visa_checker" type="hidden" value="${obj.visa_checker == null ? '' : obj.visa_checker}">` : ''}
                ${this.employee_discount && Object.keys(this.employee_discount).length > 0 ? `<input name="employee_discount" type="hidden" value='${JSON.stringify(this.employee_discount)}'>` : ''}
                ${type == 'employee_discount' ? `<input name="institute_slug" type="hidden" value="${this.courseCalculatorResult?.course?.institute_slug}">` : ''}
                ${type == 'employee_discount' ? `<input name="course_slug" type="hidden" value="${this.courseCalculatorResult?.course?.course_slug}">` : ''}

                ${obj.residence_id == 'custom_residence' ? `<input name="custom_residence[description]" type="hidden" value="${this.calculatorData.custom_residence.description}">` : ''}
                ${obj.residence_id == 'custom_residence' ? `<input name="custom_residence[price]" type="hidden" value="${this.calculatorData.custom_residence.price}">` : ''}
                
                ${obj.airport_id == 'custom_airport' ? `<input name="custom_airport[description]" type="hidden" value="${this.calculatorData.custom_airport.description}">` : ''}
                ${obj.airport_id == 'custom_airport' ? `<input name="custom_airport[price]" type="hidden" value="${this.calculatorData.custom_airport.price}">` : ''}
            `;
        },

        getInstituteVacation() {
            if (!this.institute_id) {
                return;
            }

            axios.get(this.base_url + '/api/get-institute-vacation', {
                params: {
                    institute_id: this.institute_id,
                },
            }).then((response) => {
                this.vacation = response.data;
                this.generateDisabledVacationDates();
            }).catch((error) => {
                console.error('Error fetching vacation:', error);
            });
        },

        generateDisabledVacationDates() {
            this.disabledVacationDates = [];
            if (this.vacation && Array.isArray(this.vacation)) {
                this.vacation.forEach(vacation => {
                    const fromDate = new Date(vacation.from_date);
                    const toDate = new Date(vacation.to_date);

                    if (fromDate instanceof Date && toDate instanceof Date && !isNaN(fromDate) && !isNaN(toDate)) {
                        for (let date = new Date(fromDate); date <= toDate; date.setDate(date.getDate() + 1)) {
                            this.disabledVacationDates.push(new Date(date));
                        }
                    }
                });
            }
        },

        async instituteVacationChecker() {
            // Cancel previous vacation request if exists
            if (this.vacationAbortController) {
                this.vacationAbortController.abort();
            }

            if (!this.calculatorData.start_date || !this.calculatorData.course_weeks || this.isVacationCheckInProgress) {
                return;
            }

            // Create new AbortController for this request
            this.vacationAbortController = new AbortController();

            this.isVacationCheckInProgress = true;

            try {
                const response = await axios.get(this.base_url + '/institute-vacation-checker', {
                    signal: this.vacationAbortController.signal,
                    params: {
                        institute_id: this.institute_id,
                        date: this.calculatorData.start_date,
                        weeks: this.calculatorData.course_weeks
                    },
                });

                this.vacation = response.data;

                if (this.vacation && this.vacation !== '' && this.vacation.weeks > 0 && this.vacationModal) {
                    this.showVacationModal();
                }

            } catch (error) {
                // Ignore cancelled requests
                if (error.code === 'ERR_CANCELED' || error.message === 'canceled') {
                    console.log('Vacation check cancelled - new request started');
                    return;
                }
                console.error('Error checking institute vacation:', error);
            } finally {
                this.isVacationCheckInProgress = false;
            }
        },

        showVacationModal() {
            this.$nextTick(() => {
                $('#institute_vacation_checker_modal').modal('show');
            });
        },

        getVacationWeeksText(weeks) {
            if (weeks == 1) {
                return this.tra.one_week;
            } else if (weeks == 2) {
                return this.tra.two_weeks;
            } else {
                return weeks + ' ' + this.tra.multiple_weeks;
            }
        },

        addVacationWeeks() {
            if (this.vacation && this.vacation.weeks > 0) {
                this.calculatorData.residence_weeks += this.vacation.weeks;
                this.hideVacationModal();
                this.debouncedGetCalculatorResult();
            }
        },

        hideVacationModal() {
            $('#institute_vacation_checker_modal').modal('hide');
            this.vacationModal = false;
            this.modalCloseTime = Date.now();
        },

        resetVacationModal() {
            this.vacationModal = true;
            this.vacation = null;
        },

        sweetAlertMSG(message, type) {
            console.log(message, type);
        }
    },

    created() {
        this.createDebouncedMethod();
        this.parseUrlParams();
    },

    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.initialLoad = false;
                if (this.hasMinimumData) {
                    this.getCourseCalculatorResult();
                    this.instituteVacationChecker();
                }
            }, 500);
            if (Object.keys(this.errors).length > 0) {
                this.sweetAlertMSG(this.tra.check_entered_data || 'يرجى التأكد من البيانات المدخلة', "error");
            }

            this.getInstituteVacation();
        });
    },
};
</script>

<style>
.course-title,
.price-info .price,
.component-title {
    font-size: 18px;
    color: #009994;
    font-weight: 700;
}

.component-title {
    margin-bottom: 3px;
}

.course-title {
    font-size: 16px;
    margin-bottom: 5px;
}

.price-info small {
    font-size: 14px;
    color: #afafaf;
}

.component-sub-title {
    font-size: 16px;
    color: #afafaf;
    font-weight: 600;
    margin-bottom: 0px;
}

.component-header-icon {
    font-size: 30px !important;
    color: #009994;
    margin-left: 15px;
    margin-top: 6px;
}

.course-row {
    padding-top: 20px;
    padding-bottom: 20px;
    border-top: 2px solid #f2f2f2;
}

.p-accordionheader-toggle-icon {
    width: 20px !important;
    height: 20px !important;
    color: #009994 !important;
    position: relative;
    z-index: 10;
    pointer-events: auto;
}

.p-accordionheader {
    pointer-events: none;
}

.p-accordionheader .head-input-fields {
    pointer-events: auto;
}

.p-accordion.p-component {
    padding-left: 50px;
    padding-right: 50px;
}

.course-tag {
    background-color: #f2f2f2 !important;
    padding: 1px 5px !important;
    border-radius: 2px !important;
    margin-top: 5px !important;
}

.course-tag .p-tag-icon {
    color: #009994 !important;
}

.course-tag .p-tag-label {
    color: #009994 !important;
    font-weight: 500;
}

.p-accordionpanel:last-child>.p-accordionheader {
    padding: 10px 0px;
}

.course-desc {
    font-size: 14px;
    color: #afafaf;
}

.p-accordionheader .head-input-fields {
    margin-right: auto;
    margin-left: 40px;
}

.p-radiobutton-checked .p-radiobutton-box {
    border-color: #009994 !important;
    background: #009994 !important;
}

.institute-discount-badge,
.sat-discount-badge {
    font-size: 13px !important;
    font-weight: 500 !important;
    color: #fff !important;
    background-color: #009994 !important;
    padding: 1px 5px !important;
    border-radius: 2px !important;
}

.sat-discount {
    background-color: #004845 !important;
}

.accordion-header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.course-sub-title {
    margin-bottom: 5px;
}


.card-watermark {
    position: relative;
    overflow: hidden;
}

.card-watermark::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: var(--logo-url);
    background-repeat: repeat;
    background-size: 150px;
    transform: rotate(30deg) scale(3);
    opacity: 0.05;
    pointer-events: none;
    z-index: 0;
}

.card-watermark .p-card-body {
    position: relative;
    z-index: 1;
}

@media (max-width: 768px) {
    .accordion-header-content {
        flex-direction: column;
        align-items: flex-start;
    }

    .p-accordionheader .head-input-fields {
        margin-right: 0px;
        margin-left: 0px;
        margin-top: 10px;
    }
}

@media (max-width: 650px) {
    .price-info {
        flex-direction: column-reverse;
    }

    .discounts-badges {
        margin-left: 0px !important;
    }

    .p-accordion.p-component {
        padding-left: 20px !important;
        padding-right: 20px !important;
    }

    .p-accordioncontent-content {
        padding: 0px !important;
    }
}
</style>
